// extracted by mini-css-extract-plugin
export default {"outerDiv":"MenuComponent_outerDiv__z27x9","ttl":"MenuComponent_ttl__mZEqK","menuCard":"MenuComponent_menuCard__inWn-"};